import update from "immutability-helper";
import React from "react";
import EditedSubjectRowCard from "./editsubjectrow";

import SubjectRowCard from "./subjectrow";

interface IState {
  inputIsValid: boolean
}

interface Props {
  onEditClick: (subject: server.dto.FavoriteSubject) => void
  onEditSave: (subject: server.dto.FavoriteSubject) => void
  onDeleteClick: (subject: server.dto.FavoriteSubject) => void
  onCreate: (subject: server.dto.FavoriteSubject) => void

  editedItem: server.dto.FavoriteSubject
  createdItem: server.dto.FavoriteSubject
  items: server.dto.FavoriteSubject[]
}

class FavoriteSubjectPanel extends React.Component<Props, IState> {
  newItem: any;

  constructor(props) {
    super(props);

    this.state = {
      inputIsValid: true
    };
  }

  validateInput = (event) => {
    this.setState(update(this.state,
      {
        inputIsValid: { $set: event.target.value !== "" }
      }));
  };

  public render(): JSX.Element {
    return (
      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          {this.props.items.map((subject) => {
            if (this.props.editedItem && this.props.editedItem.subjectId === subject.subjectId) {
              return (
                <EditedSubjectRowCard
                  key={subject.subjectId}
                  initialSubject={subject}
                  onEdit={this.props.onEditSave}
                />
              );
            }
            return (
              <SubjectRowCard
                key={subject.subjectId}
                subject={subject}
                onEditClick={this.props.onEditClick}
                onDeleteClick={this.props.onDeleteClick}
              />
            );
          })}

          {(this.props.createdItem != null) && <EditedSubjectRowCard
            initialSubject={this.props.createdItem}
            onCreate={this.props.onCreate}
          />}
        </div>
      </div>
    );
  }
}

export default FavoriteSubjectPanel;